import styled from 'styled-components';
// styles
import { palette } from '../styles';

const Header = styled.div`
  width: 48px;
  height: 4px;
  border-radius: 4px;
  background-color: ${palette.grey030};
  margin: 12px auto;
`;

export default Header;
